function MembershipComparisonTable({ communityPlan, proPlan }) {
  const features = [
    {
      category: 'Content & Learning',
      items: [
        {
          name: 'Free educational content & seminars',
          community: true,
          pro: true,
          description: 'Access to our library of free educational materials'
        },
        {
          name: 'Premium content & events',
          community: 'Pay-per-access',
          pro: 'Free or discounted',
          description: 'Advanced workshops, exclusive webinars, and specialized content'
        }
      ]
    },
    {
      category: 'Community & Networking',
      items: [
        {
          name: 'Member-only events',
          community: true,
          pro: true,
          description: 'Exclusive networking events and community gatherings'
        },
        {
          name: 'Discussion groups and forums',
          community: true,
          pro: true,
          description: 'Connect with like-minded members in our online community'
        },
        {
          name: 'Priority registration',
          community: false,
          pro: true,
          description: 'Get first access to popular workshops and limited-seat events'
        }
      ]
    },
    {
      category: 'Services & Support',
      items: [
        {
          name: 'Customer support',
          community: 'Standard',
          pro: 'Priority',
          description: 'Get help when you need it'
        },
        {
          name: 'Professional services',
          community: 'Standard pricing',
          pro: 'Member pricing',
          description: 'Consultations and specialized services at discounted rates'
        },
        {
          name: 'Early access to new tools',
          community: false,
          pro: true,
          description: 'Be among the first to try new programs and resources'
        }
      ]
    },
    {
      category: 'Recognition & Perks',
      items: [
        {
          name: 'Member recognition',
          community: false,
          pro: 'Pro Member badge',
          description: 'Recognition as a supporter of our mission'
        },
        {
          name: 'Annual savings',
          community: false,
          pro: 'Up to $20/year',
          description: 'Save money with annual Pro membership'
        }
      ]
    }
  ];

  const renderFeatureValue = (value) => {
    if (value === true) {
      return (
        <div className="flex justify-center">
          <svg className="h-5 w-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
      );
    }
    if (value === false) {
      return (
        <div className="flex justify-center">
          <svg className="h-5 w-5 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
      );
    }
    return (
      <div className="text-center text-sm font-medium text-gray-700">
        {value}
      </div>
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">
          Feature Comparison
        </h3>
        <p className="text-sm text-gray-600 mt-1">
          Compare what's included in each membership tier
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Features
              </th>
              <th className="px-6 py-4 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Community Member
                <div className="text-lg font-bold text-gray-900 mt-1">Free</div>
              </th>
              <th className="px-6 py-4 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Pro Member
                <div className="text-lg font-bold text-gray-900 mt-1">
                  Starting at $30/quarter
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {features.map((category, categoryIndex) => (
              <>
                <tr key={`category-${categoryIndex}`} className="bg-gray-50">
                  <td colSpan={3} className="px-6 py-3">
                    <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wide">
                      {category.category}
                    </h4>
                  </td>
                </tr>
                {category.items.map((feature, featureIndex) => (
                  <tr key={`feature-${categoryIndex}-${featureIndex}`} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div>
                        <div className="text-sm font-medium text-gray-900">
                          {feature.name}
                        </div>
                        <div className="text-sm text-gray-500">
                          {feature.description}
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      {renderFeatureValue(feature.community)}
                    </td>
                    <td className="px-6 py-4">
                      {renderFeatureValue(feature.pro)}
                    </td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
        </table>
      </div>

      {/* Bottom CTA */}
      <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="flex-1 sm:flex-none px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors">
            Join Community - Free
          </button>
          <button className="flex-1 sm:flex-none px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors">
            Upgrade to Pro
          </button>
        </div>
      </div>
    </div>
  );
}

export default MembershipComparisonTable;